import {
    FETCH_DEPSEARCH_BEGIN,
    FETCH_DEPSEARCH_SUCCESS,
    FETCH_DEPSEARCH_ERROR,
    FETCH_DEPSEARCH_FULLRESET,
    SET_DEPSEARCH_CRITERES,
    DELETE_DEPANNAGE_BEGIN,
    DELETE_DEPANNAGE_ERROR,
    DELETE_DEPANNAGE_RESET,
    DELETE_DEPANNAGE_SUCCESS
} from '../actions/depSearchActions'

const initialState = {
    deps: [],
    livs: [],
    livraisons: [],
    criteres: {},
    loading: false,
    error: false,
    errorDetails: {},
    deleteDepannage: {
        deleting: false,
        deleted: false,
        error: false
    }
}

export default function depSearchReducer(state = initialState, action) {
    let nextState
    switch (action.type) {
        case FETCH_DEPSEARCH_BEGIN:
            return {
                ...state,
                loading: true,
                error: false,
                errorDetails: {}
            }

        case FETCH_DEPSEARCH_SUCCESS:
            nextState = {
                ...state,
                deps: action.payload.deps.deps,
                livs: action.payload.deps.livs,
                loading: false,
                error: false,
                errorDetails: {}
            }
            return nextState

        case FETCH_DEPSEARCH_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                errorDetails: action.payload.error
            }
        case FETCH_DEPSEARCH_FULLRESET:
            return {
                ...state,
                loading: false,
                error: false,
                deps: [],
                livs: []
            }
        case SET_DEPSEARCH_CRITERES:
            return {
                ...state,
                criteres: action.payload.criteres
            }
        // DELETE DEPANNAGE
        case DELETE_DEPANNAGE_BEGIN:
            return {
                ...state,
                deleteDepannage: {
                    deleted: false,
                    deleting: true,
                    error: false,
                    ticket: action.payload.ticket
                }
            }
        case DELETE_DEPANNAGE_ERROR:
            // Réponse d'une suppression abandonnée (RESET depuis — page
            // quittée en pleine suppression) : pas pour le modal ouvert.
            if (action.payload.ticket !== state.deleteDepannage.ticket) return state
            return {
                ...state,
                deleteDepannage: {
                    deleted: false,
                    deleting: false,
                    error: action.payload.error
                }
            }
        case DELETE_DEPANNAGE_SUCCESS:
            if (action.payload.ticket !== state.deleteDepannage.ticket)
                // Abandonnée (cf. ERROR) mais bien supprimée : seule sa
                // ligne quitte la liste — ni ✓ dans le modal d'une autre
                // fiche, ni résultats d'une recherche périmée.
                return {
                    ...state,
                    deps: (state.deps || []).filter(
                        (d) => d.id !== action.payload.id
                    ),
                    livs: (state.livs || []).filter(
                        (liv) => liv.id !== action.payload.id
                    )
                }
            return {
                ...state,
                deps: action.payload.deps,
                // Le DELETE ne renvoie pas les livraisons : on retire celles de
                // la fiche supprimée (DepLivraison.dep en CASCADE ; l'id d'une
                // ligne livraison EST l'id de son dépannage).
                livs: (state.livs || []).filter(
                    (liv) => liv.id !== action.payload.id
                ),
                deleteDepannage: {
                    deleted: true,
                    deleting: false,
                    error: false
                }
            }
        case DELETE_DEPANNAGE_RESET:
            return {
                ...state,
                deleteDepannage: {
                    deleted: false,
                    deleting: false,
                    error: false
                }
            }
        default:
            return state
    }
}